//Redux Toolkit
import { createSelector } from "@reduxjs/toolkit";
import { selectRteApiData } from "./select-rte-api-data";
import { RteTileData } from "../../../models/rte/rte-tile-data";

export const selectRteTileData = createSelector(
	[selectRteApiData],
	(rteApiData) => {
		let rteTileData = {
			showTile: false,
			tileClass: "",
			imageUrl: "",
			status: "",
			tileText: "",
			tileTextTwo: "",
			textDivClass: "",
			ctaClassOne: "",
			ctaClassTwo: "",
		} as RteTileData;

		if (
			rteApiData.status.toLowerCase() == "teaser" ||
			rteApiData.status.toLowerCase() == "live"
		) {
			rteTileData.showTile = true;
			rteTileData.imageUrl =
				"\\Assets\\drh\\img\\rte\\L1_Red-Tag-Event_Logo_White.svg";
		}

		if (rteApiData.status.toLowerCase() == "teaser") {
			rteTileData.tileClass = "teaser-red-tag-tile";
			rteTileData.textDivClass = "teaser-red-tag-cta-one";
			rteTileData.tileTextTwo = "Act now";
			rteTileData.ctaClassOne = "rteCtaTeaserTextOne";
			rteTileData.ctaClassTwo = "rteCtaTeaserTextTwo";
			rteTileData.tileText =
				"Deals are only " + rteApiData.countdownText + " away.";
		} else if (rteApiData.status.toLowerCase() == "live") {
			rteTileData.tileText = "More homes. More savings. Deals end May 3.";
			rteTileData.textDivClass = "live-red-tag-cta-one";
			rteTileData.tileTextTwo = "Act now";
			rteTileData.tileClass = "live-red-tag-tile";
			rteTileData.ctaClassOne = "rteCtaLiveTextOne";
			rteTileData.ctaClassTwo = "rteCtaLiveTextTwo";
		}

		return rteTileData;
	},
);
